import React from "react";
import { Outlet } from "react-router-dom";

function RegisterLayout() {

    return (
        <div className="text-center three-login-bg login_center form-padding-reg min-vh-100" >
            <Outlet />
        </div>
    )
}

export default RegisterLayout